// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { footerContainerStyles } from "@guestsupply/Overrides/Widgets/Footer/FooterContainer";
import { color, xScreen } from "@guestsupply/XDL/Utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

footerContainerStyles.subscribeGridItem = {
    width: [12, 12, 12, 9.5, 9.5] as any,
};

footerContainerStyles.containerStyledWrapper = {
    css: css`
        &&& {
            p {
                line-height: 20px;
                font-size: 12px;
                color: ${getColor("common.ui1")};
                font-weight: 400;
                margin: 0;
            }
        }
    `,
};

footerContainerStyles.topSectionGridContainer = {
    gap: 0,
    css: css`
        border-bottom: 1px solid ${getColor("common.border")};
    `,
    offsetCss: css`
        padding: 24px 0;
    `,
};
footerContainerStyles.socialIconsGridItem = {
    width: [12, 12, 12, 2.5, 2.5] as any,
    css: css`
        div[class^="Wrapper"] {
            margin: auto;
        }
    `,
};

footerContainerStyles.bottomSectionStyledWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 16px;
        margin-top: 16px;
        ${xScreen("lte", "md")} {
            flex-direction: column;
            align-items: flex-start;
        }
    `,
};

footerContainerStyles.copyRightGridItem = {
    css: css`
        flex: 1;
        flex-basis: 255px;
        ${xScreen("lte", "md")} {
            flex-basis: initial;
        }
    `,
};
footerContainerStyles.termsGridItem = {
    css: css`
        &&& {
            .list-wrapper {
                padding: 0;
                text-transform: initial;
                line-height: 17px;
                .links-wrapper {
                    display: inline-flex;
                    align-items: center;
                    padding-top: 0;
                    padding-right: 11px;
                    line-height: 20px;
                    margin-bottom: 0;
                    &::after {
                        content: "|";
                        padding-left: 11px;
                        color: ${getColor("common.ui1")};
                    }
                    &:last-child {
                        padding-right: 0;

                        &::after {
                            content: "";
                            padding-left: 0;
                        }
                    }
                }
            }
            div[class^="ContentWrapper"] {
                display: flex;
                line-height: 20px;
            }
            a,
            a span {
                color: ${color("common.ui4")};
                font-size: 12px;
                line-height: 15px;
            }
            a:hover,
            a span:hover {
                color: ${color("common.ui8")};
            }
        }
    `,
};
footerContainerStyles.middleSectionGridContainer = {
    gap: 20,
    css: css`
        border-bottom: 1px solid ${getColor("common.border")};
    `,
};
footerContainerStyles.middleSectionGridItem = {
    width: 12,
};
